<template>
  <div>
    <Nav></Nav>
    <b-container fluid class="mt-3">
      <ReportSearchBar :init="routeQuery.fini" :end="routeQuery.ffin" :sucursales="routeQuery.sucursales" :emitOnChange="false" @search="searchRecv" @changed="changeData"></ReportSearchBar>
      <b-row>
        <b-col>
          <h1>Movimientos de Inventario</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="2">
          <b-button variant="success" @click="$bvModal.show('modal-newStockPicking')">Crear Movimiento</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" @keyup="page = 1" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-table ref="selectableTable" :per-page="byPage" :current-page="page" :filter="search" selectable @row-selected="onRowSelected" small striped hover :items="pickings" :fields="pickingsLabels" responsive> <!--:fields="pickingsLabels"-->
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(status)="data">
              <b-badge :variant="statusBadge(data.item.status).variant">{{ statusBadge(data.item.status).text
                }}</b-badge>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="success" @click="$router.push('/movimiento/' + data.item.id)" class="mr-1">
                +Info
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="page" :total-rows="pickings.length" :per-page="byPage"
            aria-controls="my-table"></b-pagination>
        </b-col>
      </b-row>
      <b-modal id="modal-newStockPicking" :hide-footer="true" size="xl" title="Crear Movimiento de Inventario">
        <b-row>
          <b-col lg="12" cols="12">
            <b-form-group label="Tipo de Movimiento" description="Selecciona el tipo de movimiento">
              <vu-select @input="modifiedPickingType" v-model.number="newStockPicking.picking_type_id"
                :options="pickingTypes" :reduce="(x) => x.id" label="barcode"></vu-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="newStockPicking.picking_type_id>0">
          <b-col lg="6" cols="12">
            <b-form-group label="De" description="Selecciona la ubicacion origen">
              <vu-select :disabled="newStockPicking.locked_src_location" v-model.number="newStockPicking.location_id"
                :options="locations.filter(x=>x.type_usage=='inventory'||x.type_usage=='internal')" :reduce="(x) => x.id" label="complete_name"></vu-select>
            </b-form-group>
          </b-col>
          <b-col lg="6" cols="12">
            <b-form-group label="Hacia" description="Selecciona la ubicacion destino">
              <vu-select :disabled="newStockPicking.locked_dst_location"
                v-model.number="newStockPicking.location_dest_id" :options="locations.filter(x=>x.type_usage=='inventory'||x.type_usage=='internal')" :reduce="(x) => x.id"
                label="complete_name"></vu-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" lg="6">
            <b-form-group label="Nombre" description="Nombre para identificar el movimiento">
              <b-form-input v-model="newStockPicking.picking_name" type="text" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" lg="6">
            <b-form-group label="Nota" description="Notas del movimiento">
              <b-form-input v-model="newStockPicking.note" type="text" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="12">
            <b-form-group label="Fecha Esperada:" description="Fecha en la que esperas realizar el movimiento">
              <b-form-input v-model="newStockPicking.scheduled_date" type="date" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="12">
            <b-form-group label="Fecha Maxima:" description="Fecha en la que debe estar el movimiento">
              <b-form-input v-model="newStockPicking.date_deadline" type="date" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button variant="success" @click="createPicking">Crear</b-button>
          </b-col>
        </b-row>
      </b-modal>
    </b-container>

  </div>
</template>
<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import router from "../router"
import moment from 'moment';
import ReportSearchBar from "./reports/searchBar/ReportSearchBar.vue";
export default {
  name: "Movimientos",
  components: {
    Nav,ReportSearchBar
  },

  data() {
    return {
      routeQuery:{
        page:null,
        search:null,
        fini:null,
        ffin:null,
        sucursales:null
      },
      page:1,
      byPage:20,
      newStockPicking: {
        picking_type_id: null,
        location_id: null,
        location_dest_id: null,

        picking_name: "",
        note: "",

        scheduled_date: "",
        date_deadline: "",

        move_type: "direct",
        locked_src_location: false,
        locked_dst_location: false
      },
      initialDate: "",
      lastDate: "",
      allSucsArray: [],
      pickingTypes: [],
      locations: [],
      search: "",
      pickings: [],
      actualSucursal: {
        id: null
      },
      pickingsLabels: [
        { key: "id", label: "ID" },
        { key: "picking_name", label: "Referencia", sortable: true },
        { key: "src_location.complete_name", label: "Desde", sortable: true },
        { key: "dst_location.complete_name", label: "Hacia", sortable: true },
        { key: "picking_type.name", label: "Operacion", sortable: true },
        { key: "scheduled_date", label: "Fecha Planeada", sortable: true },
        { key: "create_date", label: "Fecha de creacion", sortable: true },
        { key: "state", label: "Status", sortable: true },
        { key: "buttons", label: "" }
      ]
    };
  },

  computed: {

  },
  watch: {},
  mounted() {
    this.getPickingTypes()
    this.getLocations()
    console.log("mounted")
    this.routeQuery.search=this.$route.query.search
    this.routeQuery.ffin=this.$route.query.ffin
    this.routeQuery.fini=this.$route.query.fini
    this.routeQuery.sucursales=this.$route.query.sucursales
    this.initialDate = this.routeQuery.fini
    this.lastDate = this.routeQuery.ffin
    console.log("before split")
    console.log(this.routeQuery.sucursales)
    if(this.routeQuery.sucursales!=null && this.routeQuery.sucursales!=undefined && this.routeQuery.sucursales!=""){
      this.allSucsArray = this.routeQuery.sucursales.split(",")
    }
    console.log(this.routeQuery)
    this.getMovimientos()
  },
  created() {

  },
  methods: {
    updateQuery(){
      console.log(this.$route.query)
      const pendingUpdates = { ...this.$route.query }
      Object.entries(this.routeQuery).forEach(([key, value]) => {
        if (value === null || value === undefined || value=="") {
          delete pendingUpdates[key]
        } else {
          pendingUpdates[key] = value
        }
      })
      console.log("updating")
      console.log(pendingUpdates)
      
      // Check if we're navigating to the same route with the same query params
      const isSameRoute = Object.keys(pendingUpdates).length === Object.keys(this.$route.query).length &&
        Object.keys(pendingUpdates).every(key => pendingUpdates[key] === this.$route.query[key]);
      
      if (!isSameRoute) {
        this.$router.replace({
          query: pendingUpdates
        }).catch(err => {
          // Ignore NavigationDuplicated errors
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
      this.getMovimientos()

    },
    changeData(e){
      console.log(e)
      this.routeQuery.ffin=moment(e.end).format('YYYY-MM-DD');
      this.routeQuery.fini=moment(e.init).format('YYYY-MM-DD');
      this.routeQuery.sucursales=e.sucursales.join(",");
      this.getMovimientos()
      this.updateQuery()
    },
    searchRecv(p) {
      this.initialDate = moment(p.initDate).format('YYYY-MM-DD');
      this.lastDate = moment(p.endDate).format('YYYY-MM-DD');
      this.allSucsArray = p.sucursales
      this.getMovimientos()
      this.updateQuery()

    },
    onRowSelected(item){
      console.log(item)
      if(item.length>0){
        this.$router.push('/movimiento/' + item[0].id)
      }
      this.$refs.selectableTable.clearSelected()
    },
    modifiedPickingType() {
      console.log("modifiedPickingType")
      let pt = this.pickingTypes.find((x) => x.id == this.newStockPicking.picking_type_id)
      if (pt.default_src_location_id != null) {
        this.newStockPicking.locked_src_location = true
        this.newStockPicking.location_id = pt.default_src_location_id
      } else {
        this.newStockPicking.locked_src_location = false
        this.newStockPicking.location_id = null
      }
      if (pt.default_dst_location_id != null) {
        this.newStockPicking.locked_dst_location = true
        this.newStockPicking.location_dest_id = pt.default_dst_location_id
      } else {
        this.newStockPicking.locked_dst_location = false
        this.newStockPicking.location_dest_id = null
      }
    },
    createPicking(){
      let that=this
      axios.post("/stockpicking",this.newStockPicking)
        .then(function (res) {
          router.push('/movimiento/' + res.data.id)
      this.getCompras()
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
    getPickingTypes() {
      let that = this
      axios.get("/stockpicking/types")
        .then(function (res) {
          that.pickingTypes = res.data
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
    getLocations() {
      let that = this
      axios.get("/stocklocations")
        .then(function (res) {
          that.locations = res.data
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
   
    newPOError(evt) {
      console.log("error reading")
      console.log(evt)
      this.getMovimientos()
      this.makeToast("danger", "Error", evt.data)
    },
    statusBadge(status) {
      let rtn = { variant: "", text: status }
      switch (status) {
        case "draft":
          rtn.variant = "warning"
          rtn.text = "Borrador"
          break;
        case "sent":
          rtn.variant = "warning"
          rtn.text = "Enviado"
          break;
        case "done":
          rtn.variant = "success"
          rtn.text = "Enviado"
          break;
        case "canceled":
          rtn.variant = "danger"
          rtn.text = "Cancelado"
          break;
      }
      return rtn
    },
    newPOCreated(evt) {
      console.log(evt)
      router.push('/movimiento/' + evt)
      this.getMovimientos()
    },
    getMovimientos() {
      console.log("getMovimientos")
      console.log("/stockpickings?sucursales=" + this.allSucsArray.join(",") + "&init_date=" + this.initialDate + "&end_date=" + this.lastDate)
      let that = this
      axios.get("/stockpickings?sucursales=" + this.allSucsArray.join(",") + "&init_date=" + this.initialDate + "&end_date=" + this.lastDate) 
        .then(function (res) {
          that.pickings = res.data
        }).catch(function (err) {
          console.error(err)
        })
    },
    makeToast(variant = null, title = "", text = "") {
      this.$bvModal.msgBoxOk(text, {
        title: title,
        okVariant: variant,
        centered: true
      })
      // this.$bvToast.toast(text, {
      //   title: title,
      //   variant: variant,
      //   solid: true,
      //   appendToast: true,
      // });
    },
  },
};
</script>
